export const module16InitialState = {
  module16: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      CrabWearMustash: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CrabwearGlasses: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SurfBoardRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SurfBoardBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BeachChairRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BeachChairBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SnowConeBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SnowConeRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FrisbeeBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FloatationBall: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FerrisWheelRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FerrisWheelBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      ArcadePurple: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      ArcadeBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StandHotDogs: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StandTacos: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CrabHawaiian: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CrabSuit: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module16Reducer = (state = module16InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE16_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        CrabWearMustash: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CrabwearGlasses: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SurfBoardRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SurfBoardBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BeachChairRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BeachChairBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SnowConeBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SnowConeRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FrisbeeBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FloatationBall: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FerrisWheelRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FerrisWheelBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        ArcadePurple: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        ArcadeBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StandHotDogs: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StandTacos: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CrabHawaiian: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CrabSuit: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SnowConeBlue\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"StandTacos\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module16: {
          ...state.module16,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module16InitialState,
      };
    }
    case 'MODULE16_SET_DAY': {
      return {
        ...state,
        module16: {
          ...state.module16,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE16_SET_GameDetials': {
      return {
        ...state,
        module16: {
          ...state.module16,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE16_SET_stepCompleted': {
      return {
        ...state,
        module16: {
          ...state.module16,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE16_SET_dayCompleted': {
      return {
        ...state,
        module16: {
          ...state.module16,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE16_SET_CAMERAOPEN': {
      return {
        ...state,
        module16: {
          ...state.module16,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE16_SET_KEY': {
      return {
        ...state,
        module16: {
          ...state.module16,
          keys: action.payload,
        },
      };
    }
    case 'MODULE16_SET_COIN': {
      return {
        ...state,
        module16: {
          ...state.module16,
          coins: action.payload,
        },
      };
    }
    case 'MODULE16_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module16: {
          ...state.module16,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE16_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module16: {
          ...state.module16,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE16_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module16: {
          ...state.module16,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE16_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module16: {
          ...state.module16,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE16_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module16: {
          ...state.module16,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE16_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module16: {
          ...state.module16,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE16_SET_REWARD11': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            CrabWearMustash: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD11_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            CrabWearMustash: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD12': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            CrabwearGlasses: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD12_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            CrabwearGlasses: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD21': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            SurfBoardRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD21_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            SurfBoardRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD22': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            SurfBoardBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD22_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            SurfBoardBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD31': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            BeachChairRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD31_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            BeachChairRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD32': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            BeachChairBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD32_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            BeachChairBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD41': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            SnowConeBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD41_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            SnowConeBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD42': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            SnowConeRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD42_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            SnowConeRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD51': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            FrisbeeBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD51_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            FrisbeeBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD52': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            FloatationBall: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD52_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            FloatationBall: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD61': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            FerrisWheelRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD61_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            FerrisWheelRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD62': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            FerrisWheelBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD62_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            FerrisWheelBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD71': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            ArcadePurple: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD71_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            ArcadePurple: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD72': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            ArcadeBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD72_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            ArcadeBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD81': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            StandHotDogs: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD81_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            StandHotDogs: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD82': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            StandTacos: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_REWARD82_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            StandTacos: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_PRIZE1': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            CrabHawaiian: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            CrabHawaiian: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_PRIZE2': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            CrabSuit: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module16: {
          ...state.module16,
          rewards: {
            ...state.module16.rewards,
            CrabSuit: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE16_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module16: {
          ...state.module16,
          unlockedDays: {
            ...state.module16.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE16_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module16: {
          ...state.module16,
          unlockedDays: {
            ...state.module16.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE16_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module16: {
          ...state.module16,
          unlockedDays: {
            ...state.module16.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE16_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module16: {
          ...state.module16,
          unlockedDays: {
            ...state.module16.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE16_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module16: {
          ...state.module16,
          unlockedDays: {
            ...state.module16.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE16_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module16: {
          ...state.module16,
          unlockedDays: {
            ...state.module16.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE16_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module16: {
          ...state.module16,
          unlockedDays: {
            ...state.module16.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE16_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module16: {
          ...state.module16,
          unlockedDays: {
            ...state.module16.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module16Reducer;
